import { render } from "./CoachesList.vue?vue&type=template&id=18463066&scoped=true"
import script from "./CoachesList.vue?vue&type=script&lang=js"
export * from "./CoachesList.vue?vue&type=script&lang=js"

import "./CoachesList.vue?vue&type=style&index=0&id=18463066&scoped=true&lang=css"

import exportComponent from "D:\\Users\\וינברג\\Documents\\Vue\\main-prj-01-starting-setup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18463066"]])

export default __exports__